import {useNavigate} from '@tanstack/react-router'

export type ProspectClickFilters = {
    manager?: string
    capacityBucket?: string
    engagementLevel?: string
    totalGiftsMin?: number
    totalGiftsMax?: number
}

/**
 * Returns a callback that navigates to the prospects list page with the given
 * filters applied as search params. Used by analytics components to link chart
 * elements and table rows to the filtered prospects view.
 */
export function useProspectNavigation(orgId: string) {
    const navigate = useNavigate()
    return (filters: ProspectClickFilters) => {
        navigate({
            to: '/organizations/$orgId/prospects',
            params: {orgId},
            search: {
                ...(filters.manager ? {manager: filters.manager} : {}),
                ...(filters.capacityBucket ? {capacityBuckets: [filters.capacityBucket]} : {}),
                ...(filters.engagementLevel ? {engagementLevels: [filters.engagementLevel]} : {}),
                ...(filters.totalGiftsMin !== undefined
                    ? {totalGiftsMin: filters.totalGiftsMin}
                    : {}),
                ...(filters.totalGiftsMax !== undefined
                    ? {totalGiftsMax: filters.totalGiftsMax}
                    : {}),
            },
        })
    }
}
